import { createContext } from "react"

let TABS = createContext({
    tabs:[],
    setTabs:(tab)=>{
        const allTabs = this.tabs;
        this.tabs = [...allTabs,tab];
    }
});

export default TABS;